import * as React from 'react';
var joinClassNames = function () {
    var classnames = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classnames[_i] = arguments[_i];
    }
    return classnames.join(' ');
};
var selectClassName = function (element) {
    return (element.props && element.props.className) || '';
};
var ChildrenWithClass = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children;
    var clonedChildren = React.Children.toArray(children).map(function (child) {
        return React.cloneElement(child, {
            className: joinClassNames(selectClassName(child), className),
        });
    });
    return React.createElement(React.Fragment, null, clonedChildren);
};
export { ChildrenWithClass };
//# sourceMappingURL=ChildrenWithClass.js.map